<template>
  <form action="https://pollygot.us15.list-manage.com/subscribe/post?u=3c3e68a463cd5f23b2f8b59f5&amp;id=10be3ff53e" method="post" id="subscribe-form" name="subscribe-form" target="_blank">
    <div id="mc_embed_signup_scroll">
    	<h4>Sign up to receive one Mental Model to your inbox every day.</h4>
      <md-field>
        <label v-if="!email.length">Email Address *</label>
        <input v-model="email" type="email" value="" name="EMAIL" class="required email" id="mce-EMAIL"/>
      </md-field>
      <md-field>
        <label v-if="!first.length">First Name *</label>
        <input v-model="first" type="text" value="" name="FNAME" class="" id="mce-FNAME"/>
      </md-field>
      <md-field>
        <label v-if="!last.length">Last Name *</label>
        <input v-model="last" type="text" value="" name="LNAME" class="" id="mce-LNAME"/>
      </md-field>
      <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
      <div style="position: absolute; left: -5000px;" aria-hidden="true"><input type="text" name="b_3c3e68a463cd5f23b2f8b59f5_10be3ff53e" tabindex="-1" value=""></div>
      <div class="right">
        <md-button type="submit" value="Subscribe" name="subscribe" class="btn-no-margin md-raised">Subscribe</md-button>
      </div>
    </div>
  </form>
</template>



<script>
export default {
  props: [],
  name: 'Subscribe',
  data: () => ({
    email: '',
    first: '',
    last: ''
  })
}
</script>
<style lang="scss" scoped>
form {
  margin-top: 50px;
  input {
    outline: none;
    border: 0;
    width: 100%;
    font-size: 1em;
  }
}
.right {
  text-align: right;
  .btn-no-margin {
    margin: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Signup.vue